import { Attr, HasOne, Model } from 'spraypaint';
import { Customer, VehicleType } from './';
import ApplicationRecord from './ApplicationRecord';

@Model()
export default class Vehicle extends ApplicationRecord {
  static jsonapiType = 'vehicles';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Rego',
        value: 'rego',
        width: 100,
      },
      {
        text: 'Make',
        value: 'make',
      },
      {
        text: 'Model',
        value: 'model',
      },
      {
        text: 'Type',
        value: 'vehicleType.name',
      },
      {
        text: 'Colour',
        value: 'colour',
      },
      {
        text: 'Customer',
        value: 'owner.firstName',
        width: 200,
      },
    ];
  }

  static scopeFactory() {
    return Vehicle.includes(['vehicleType', 'owner']).where({ deleted: false });
  }

  @Attr() rego: string;
  @Attr() make: string;
  @Attr() model: string;
  @Attr() colour: string;
  @Attr() deleted: boolean; // Used for soft deletion

  @HasOne() vehicleType: VehicleType;
  @HasOne() owner: Customer;

  get fullName() {
    return `${this.rego} - ${this.colour} ${this.make} ${this.model}`;
  }
}
